import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { PlanSubTab } from "./UserPageTab";

type Props = {
  value: PlanSubTab;
  onChange: (tab: PlanSubTab) => void;
  showPurchase: boolean;
};

const SegmentButton = ({
  active,
  labelKey,
  icon,
  onClick,
}: {
  active: boolean;
  labelKey: string;
  icon: string;
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`type-inherit-font flex-col-el flex-center gap-1 w-full h-[130px] px-2 py-2 rounded-2xl border-2 border-solid cursor-pointer transition-colors shadow-[0_3px_0_rgba(63,74,97,0.14),0_4px_10px_rgba(63,74,97,0.08)] active:translate-y-[2px] ${
      active
        ? "border-green-80 bg-green-60 text-textcolor-black"
        : "border-outline bg-white text-textcolor-black/60 hover:bg-green-40/20"
    }`}
  >
    <div className="flex-col-el flex-center w-[48px] h-[48px] shrink-0">
      <span className="material-symbols-outlined type-hero !leading-none">{icon}</span>
    </div>
    <p className="type-text type-sm leading-tight whitespace-pre text-center">{I18n.t(labelKey)}</p>
  </button>
);

export const PlanSegmentControl = ({ value, onChange, showPurchase }: Props) => {
  const play = usePlaySound();
  const handleClick = (tab: PlanSubTab) => () => {
    play();
    onChange(tab);
  };

  return (
    <div className="flex-col-el gap-3 w-full">
      <SegmentButton
        active={value === PlanSubTab.CURRENT}
        labelKey="MSG_USER_PLAN_SUBTAB_CURRENT"
        icon="workspace_premium"
        onClick={handleClick(PlanSubTab.CURRENT)}
      />
      {showPurchase && (
        <SegmentButton
          active={value === PlanSubTab.PURCHASE}
          labelKey="MSG_USER_PLAN_SUBTAB_PURCHASE"
          icon="shopping_cart"
          onClick={handleClick(PlanSubTab.PURCHASE)}
        />
      )}
    </div>
  );
};
